<template>
  <div>
    <PageHeader :items="items" />
    <b-tabs content-class="mt-2">
      <b-tab title="Coupon Code">
        <validation-observer ref="simpleRules">
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <TextInput
                    v-model="form.couponNumber"
                    type="text"
                    :label="$t('Coupon Code')"
                    :tooltipMessage="$t('Coupon Code')"
                    :required="true"
                    :key="form.couponNumber"
                    :disabled="true"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <TextInput
                    v-model="form.createdUser"
                    type="text"
                    :label="$t('creator')"
                    :required="false"
                    :disabled="true"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Start Date"
                    rules="required"
                  >
                    <DatePicker
                      v-model="form.startDate"
                      :label="$t('startDate')"
                      :required="true"
                      :isLeftIcon="true"
                      :leftIconName="'dateIcon'"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Due Date"
                    rules="required"
                  >
                    <DatePicker
                      v-model="form.dueDate"
                      :label="$t('dueDate')"
                      :key="form.dueDate"
                      :required="true"
                      :isLeftIcon="true"
                      :leftIconName="'dateIcon'"
                      :min="minDate"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <label class="input-label form-label"
                    >{{ $t("type") }} &nbsp;<span style="color: red">*</span>
                  </label>
                  <b-form-group class="mb-0">
                    <select class="form-control" v-model="form.type">
                      <option
                        v-for="option in typeOptions"
                        :value="option.value"
                        :key="option.value"
                      >
                        {{ $t(option.text) }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    :name="
                      form.type === 'coins' ? 'freeCredits' : 'freeCases'
                    "
                    rules="required"
                  >
                    <TextInput
                      :error="errors[0]"
                      v-model="form.freeUsers"
                      type="number"
                      :label="
                        $t(
                          form.type === 'coins' ? 'freeCredits' : 'freeCases'
                        )
                      "
                      :required="true"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Amount of activations"
                    rules="required"
                  >
                    <TextInput
                      :error="errors[0]"
                      v-model="form.amountOfActivations"
                      type="number"
                      label="Amount of activations"
                      :required="true"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <div class="form-group mt-1">
                    <label class="input-label form-label" for="cars">{{
                      $t("instantlyGrantCredits/cases")
                    }}</label>

                    <input
                      id="isInstantGrant"
                      class="form-check-input-custom ml-2"
                      v-model="form.isInstantGrant"
                      type="checkbox"
                    />
                  </div>
                </b-col>
                <b-col cols="12">
                  <label class="input-label form-label" for="cars">{{
                    $t("notes")
                  }}</label>
                  <textarea
                    class="form-control"
                    rows="5"
                    v-model="form.notes"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-end gap-2">
            <router-link
              to="/coupon-codes"
              class="d-flex align-items-center gap-1 btn btn-secondary"
            >
              <feather-icon icon="XIcon" size="12" />
              <span>{{ $t("cancel") }}</span>
            </router-link>
            <b-button
              variant="primary"
              @click="updateCoupon"
              class="d-flex align-items-center gap-1"
              :disabled="isFormInvalid"
              v-if="$can(`${$route.meta.permission}.create`)"
            >
              <feather-icon icon="PlusIcon" size="12" />
              <span>{{ $t("updateCoupon") }}</span>
            </b-button>
          </div>
        </validation-observer>
      </b-tab>
      <b-tab title="History" lazy>
        <History />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import History from "./components/History.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import DatePicker from "@/components/DatePicker.vue";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    DatePicker,
    ValidationProvider,
    ValidationObserver,
    History,
  },
  mixins: [formDirtyMixin],
  computed: {
    minDate() {
      return new Date().toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("couponCodes"),
          to: "/coupon-codes",
        },
        {
          text: this.$t("edit"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.dueDate ||
        !this.form.freeUsers ||
        !this.form.startDate ||
        !this.form.amountOfActivations
      );
    },
  },
  data() {
    return {
      form: {
        startDate: "",
        couponNumber: "",
        dueDate: "",
        freeUsers: "",
        amountOfActivations: "",
        isInstantGrant: false,
        createdBy: "",
        type: "",
        createdUser: "",
        notes: "",
      },
      typeOptions: [
        { value: "coins", text: "credits" },
        { value: "cases", text: "cases" },
      ],
      originalForm: null,
    };
  },
  async mounted() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store
        .dispatch("coupons/show", this.$route.params.id)
        .then(async (res) => {
          var response = res?.data?.data;
          this.form.couponNumber = response?.couponNumber;
          this.form.dueDate = response?.dueDate;
          this.form.startDate = response?.startDate;
          this.form.freeUsers = response?.freeUsers;
          this.form.isInstantGrant = response?.isInstantGrant;
          this.form.amountOfActivations = response?.amountOfActivations;
          this.form.createdBy = response?.createdBy;
          this.form.type = response?.type;
          this.form.notes = response?.notes;
          let responseUser = await this.$store.dispatch("users/show", {
            id: this.form.createdBy,
          });
          this.form.createdUser =
            responseUser?.data?.first_name +
            " " +
            responseUser?.data?.last_name;
          this.originalForm = JSON.stringify(this.form);
        });
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  methods: {
    async updateCoupon() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            await this.$store.dispatch("coupons/update", {
              id: this.$route.params.id,
              data: {
                ...this.form,
              },
            });
            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            this.$router.push("/coupon-codes");
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
